<template>
  <div id="app">
    <Header></Header>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInUp"
      leave-active-class="animated fadeOutDown"
      mode="out-in"
    >
      <router-view />
    </transition>
    <Menu></Menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/Header';
import Menu from '@/components/Menu';
export default {
  name: 'app',
  components: {
    Header,
    Menu
  },
  computed: mapState(['isMenuActive']),
  mounted() {
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }
};
</script>

<style lang="scss">
body {
  position: relative;
  background-color: $black;
}
#app {
  width: 100%;
  height: 100vh;
  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  height: calc(var(--vh, 1vh) * 100);

  @include mq-up() {
  }

  @include mq-down() {
  }
}
</style>
